module.exports = __webpack_public_path__ + "static/assets/ca2a88ac05b09810353e810b9638f884.png";